export const getLabelStyle = (theme) => ({
  color: theme.colors.primary[9],
  fontWeight: '600',
  marginBottom: '7px',
  fontSize: theme.fontSizes.md,
});
